var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 22.6667L18.0002 16M18.0002 16L24.6668 22.6667M18.0002 16V31M31.3335 23.9047C33.3693 22.2234 34.6668 19.6799 34.6668 16.8333C34.6668 11.7707 30.5628 7.66667 25.5002 7.66667C25.136 7.66667 24.7953 7.47666 24.6104 7.1629C22.4369 3.47473 18.4242 1 13.8335 1C6.92994 1 1.3335 6.59644 1.3335 13.5C1.3335 16.9435 2.72591 20.0618 4.97841 22.3226",
    stroke: "#6868FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudPlus);
export default __webpack_public_path__ + "static/media/cloudPlus.59cab8dc5d44a50ddb11ff13d3453cdb.svg";
export { ForwardRef as ReactComponent };